<template>
  <v-app id="app">
    <v-navigation-drawer v-model="menuVisible" temporary app>
      <div style="display:flex; flex-direction:column; justify-content: space-between; height:100vh">
        <v-list>
          <v-list-tile @click="navigate('/login')" v-if="!isAuthorized">ログイン</v-list-tile>
          <v-list-tile @click="navigate('/')" v-if="isAuthorized">現在地周辺</v-list-tile>
          <v-list-tile @click="navigate('/addresses')" v-if="isAuthorized">住所一覧</v-list-tile>
          <v-list-tile @click="navigate('/admin')" v-if="isAuthorized && isAdmin">管理</v-list-tile>
          <v-list-tile @click="navigate('/pp')">プライバシーポリシー</v-list-tile>
        </v-list>
        <v-toolbar>
          v{{ versionInfo }}
        </v-toolbar>
      </div>
    </v-navigation-drawer>
    <v-toolbar app dark color="primary">
      <v-toolbar-side-icon @click="menuVisible = !menuVisible"/>
      <v-toolbar-title>{{ $router.currentRoute.meta.title || '住所検索' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="isAuthorized" flat @click="logout">ログアウト</v-btn>
    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue'
import Router from 'vue-router'
import {isAuthorized, isAdmin, sessionLogout, sessionEnded} from '@/lib/common'

Vue.use(Router)

export default {
  name: 'app',
  created () {
    this.$router.afterEach(() => {
      console.log(`App.isAuthorized ${this.isAuthorized}`)
      this.isAuthorized = isAuthorized()
      this.isAdmin = isAdmin()
    })

    document.addEventListener('visibilitychange', (event) => {
      const LAST_VISIBLE = 'lastVisible'
      if (document.hidden) {
        localStorage.setItem(LAST_VISIBLE, new Date().getTime().toString())
      } else {
        let lastVisible
        try {
          lastVisible = parseInt(localStorage.getItem(LAST_VISIBLE) || new Date().getTime())
        } catch (e) {
          lastVisible = new Date().getTime()
        }

        const duration = (new Date().getTime() - lastVisible) / 1000
        console.log(`離れていた時間: ${duration}`)
        if (duration > 30 * 60) {
          // 30分離れていたら強制ログアウト
          console.log('強制ログアウト')
          sessionEnded(this, '自動ログアウトしました')
        }
      }
      console.log(`lastVisible: ${localStorage.getItem(LAST_VISIBLE)}`)
    })
  },
  data () {
    return {
      menuVisible: false,
      isAuthorized: isAuthorized(),
      isAdmin: isAdmin(),
      versionInfo: process.env.BUILD_TIME
    }
  },
  components: {
    Router
  },
  methods: {
    logout () {
      sessionLogout(this)
    },
    navigate (path) {
      this.$router.replace(path)
      this.menuVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<style>
  .v-navigation-drawer > div > .v-list > div > .v-list__tile {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue